module.exports = __webpack_public_path__ + "static/media/lib3.cdfa723d.jpg";